import { render, staticRenderFns } from "./Postage.vue?vue&type=template&id=527afb40&scoped=true"
import script from "./Postage.vue?vue&type=script&lang=js"
export * from "./Postage.vue?vue&type=script&lang=js"
import style0 from "./Postage.vue?vue&type=style&index=0&id=527afb40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527afb40",
  null
  
)

export default component.exports